import './polyfills'
import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import Forklaringsscroll from './components/forklaringsscroll'
import StegvisVideo from '@nrk/dh-basis-stegvis-video'
import LevendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import Spesialmodul from './components/media/spesialmodul'

import './client.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends BaseElement {
  name = tag

  render() {
    if (this.features.sanityPreview) {
      import(
        './components/preview/preview-iframe-api' /* webpackChunkName: "dh-preview-iframe" */
      ).then((module) => module.initPreview(tag))
    }
    this.#loadCustomElements()

    this.addEventListener('dh-basis-scrollhistorie-trigger-activated', (e) => {
      e.preventDefault()
      this.sendGaEvent({ eventAction: 'TRIGGER-ACTIVATED', eventLabel: e.detail.triggerIndex })
    })
  }

  async #loadCustomElements() {
    safeDefine('dh-forklaringsscroll', Forklaringsscroll)
    safeDefine('dh-fs-basis-stegvis-video', StegvisVideo)
    safeDefine('dh-fs-basis-levende-stillbilde', LevendeStillbilde)
    safeDefine('dh-fs-spesialmodul', Spesialmodul)

    /* Stegvis lottie is only defined if used */
    if (
      this.features.lottie &&
      typeof customElements.get('dh-fs-basis-stegvis-lottie') === 'undefined'
    ) {
      const stegvisLottie = (
        await import('@nrk/dh-basis-stegvis-lottie' /* webpackChunkName: "dh-stegvis-lottie" */)
      ).default
      safeDefine('dh-fs-basis-stegvis-lottie', stegvisLottie)
    }

    if (this.features.kart && typeof customElements.get('dh-fs-basis-kart') === 'undefined') {
      const kart = (await import('./lib/karthistorie-chunk' /* webpackChunkName: "dh-kart" */))
        .default

      safeDefine('dh-fs-basis-kart', kart)
    }
  }

  get features() {
    return JSON.parse(this.getAttribute('features') || '{}')
  }
}

safeDefine(tag, AppElement)
